// Action map data is injection into each action based on category.
// This data is used to determine an action's behavior and specific ui elements.
const pipelineBurstActionsMap = {
  email: {
    label: 'Send email template',
    eventType: 'query',
    category: 'email',
    eventProperties: [
      { key: 'type', value: 'email' },
      { key: 'template', fieldKey: 'template_id', fieldValue: true },
    ],
    fieldLabels: {
      template_id: ({emailTemplates = []}, {fields}) => `Send ${(emailTemplates.find(n => parseInt(n.id) === parseInt(fields.template_id)) || {}).template_name} Email`,
    },
    settings: {
      category: 'template',
      requiredFields: {
        emailTemplateId: 'email:template_id',
      },
    },
  },
  text: {
    label: 'Send text template',
    eventType: 'query',
    category: 'text',
    eventProperties: [
      { key: 'type', value: 'text' },
      { key: 'template', fieldKey: 'template_id', fieldValue: true },
    ],
    fieldLabels: {
      template_id: ({textTemplates = []}, {fields}) => `Send ${(textTemplates.find(n => parseInt(n.id) === parseInt(fields.template_id)) || {}).template_name} Text`,
    },
    settings: {
      category: 'template',
      requiredFields: {
        textTemplateId: 'text:template_id',
      },
    },
  },
  todo: {
    label: 'Update Todo',
    eventType: 'automatic',
    fieldLabels: {
      status_id: ({todoStatuses = {}}, {fields}) => `Change to ${(todoStatuses.find(n => parseInt(n.id) === parseInt(fields.status_id)) || {}).status}`,
    },
    settings: {
      // category: 'todo', default to root
      requiredFields: {
        todoStatusId: 'status_id',
      },
    },
  },
  pipeline_lead: {
    label: 'Update Lead',
    eventType: 'automatic',
    fieldContext: {
      stage_id: {
        prop: 'stage_id', // defaults to main key index, but if set will overwrite,
      },
    },
    fieldLabels: {
      status_id: ({pipelineLeadStatuses = {}}, {fields}) => `Change to ${(pipelineLeadStatuses.find(n => parseInt(n.id) === parseInt(fields.status_id)) || {}).status}`,
      stage_id: ({pipelineStages= []}, {fields}) => `Move to ${(pipelineStages.find(n => parseInt(n.id) === parseInt(fields.stage_id)) || {}).pipeline_stage_name}`,
    },
    settings: {
      requiredFields: {
        stageId: 'stage_id',
        statusId: 'status_id',
      },
    },
  },
};

export default pipelineBurstActionsMap;
